import { SearchSuggestionItem } from "@/components/Search/SearchSuggestionList/SearchSuggestionItem";
import type { SuggestionListProps } from "@/components/Search/SearchSuggestionList/types";
import { TEST_IDS } from "@/constants/testIds";

export const SearchSuggestionList = ({
  suggestions,
  query,
}: SuggestionListProps) => {
  if (!suggestions?.length) {
    return null;
  }
  return (
    <ul data-testid={TEST_IDS.SEARCH_SUGGESTIONS_LIST}>
      {suggestions?.map((suggestion) => {
        return (
          <SearchSuggestionItem
            key={suggestion}
            suggestion={suggestion}
            query={query}
          />
        );
      })}
    </ul>
  );
};
